import { useUser } from '../context/UserContext';
import OnboardingModal from './Modals/OnboardingModal';

/**
 * Composant wrapper qui affiche le modal d'onboarding quand nécessaire
 * Ce composant doit être placé à la racine de l'application
 */
const OnboardingWrapper = () => {
  const {
    user,
    onboardingStep,
    showOnboarding,
    completeOnboardingStep,
    dismissOnboarding,
  } = useUser();

  if (!showOnboarding || !onboardingStep) {
    return null;
  }

  return (
    <OnboardingModal
      step={onboardingStep}
      user={user}
      onComplete={completeOnboardingStep}
      onDismiss={dismissOnboarding}
      onSkip={dismissOnboarding}
    />
  );
};

export default OnboardingWrapper;
